import clickitProductsCreate from "./clickitProductsCreate";
import clickitProductsEdit from "./clickitProductsEdit";
import clickitProductsList from "./clickitProductsList";

export default {
  create: clickitProductsCreate,
  list: clickitProductsList,
  edit: clickitProductsEdit,
};
